@if (loading()) {
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  {{ loadingTextState() }}
} @else {
  <ng-content />
}
